<template>
  <div style="margin-bottom: 24px;">
    <div style="display: flex; justify-content: space-around">
      <el-scrollbar height="480px" class="showBox">
        <p style="margin-bottom: 16px;">展示平台</p>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">鸿蒙平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateHm" v-model="checkAllHm" @change="hmHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedHm" @change="hmHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListHm" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">IOS平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateIos" v-model="checkAllIos" @change="iosHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedIos" @change="iosHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListIos" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div>
          <label style="font-weight: bold;margin-bottom: 8px;">Android平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateAndroid" v-model="checkAllAndroid" @change="androidHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedAndroid" @change="androidHandleCheckedChange">
            <el-checkbox v-for="item in channelListAndroid" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-scrollbar>
      <div style="width: 500px;">
        <el-form ref="formRef" :model="vipForm" label-width="114px">
          <el-form-item label="跳转类型：">
            <el-select v-model="jumpType" placeholder="Select" style="width: 24em">
              <el-option v-for="item in jumpTypeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="URL地址：" v-show="jumpType != 1">
            <el-input v-model="vipForm.url" placeholder="请输入需要跳转的链接" style="width:24em;"/>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="vipForm.showOrder" placeholder="排序，越大越靠前" style="width:24em;"/>
          </el-form-item>
          <el-form-item label="标题：">
            <el-input v-model="vipForm.name" placeholder="请输入标题" style="width:24em;"/>
          </el-form-item>
          <el-form-item label="展示页面：">
            <el-select v-model="showPage" placeholder="Select" style="width: 24em">
              <el-option v-for="item in showPageArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新人状态：">
            <el-radio-group v-model="newuserShow">
              <el-radio :label="0" size="large">不限</el-radio>
              <el-radio :label="1" size="large">新用户</el-radio>
              <el-radio :label="2" size="large">非新用户</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="VIP状态：">
            <el-radio-group v-model="vipShow">
              <el-radio :label="0" size="large">不限</el-radio>
              <el-radio :label="1" size="large">已开通过会员</el-radio>
              <el-radio :label="2" size="large">未开通过会员</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="展示用户：">
            <el-input v-model="vipForm.showUid" type="textarea" style="width: 24em" placeholder="请输入用户UID，多位请通过换行隔开"></el-input>
            <p style="width: 100%;font-size: 12px;line-height: 18px;padding-top: 8px;"><span style="color: #dd2200">*</span> 请输入用户UID，多位请通过换行隔开；当输入具体展示用户后，“展示平台”条件将失效。</p>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: center;">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateVipBanner, getAllChannelList } from "@/api/url";
import { urlReg } from "../../../assets/shared/reg-constant";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      vipForm: this.value.vipForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.vipForm.img:'',

      //跳转类型
      jumpTypeArray: [
        {label: "不跳转",value: 1},
        {label: "跳转到内部浏览器",value: 2},
        {label: "跳转到外部浏览器",value: 3}
      ],
      jumpType: this.value.vipForm.jumpType?this.value.vipForm.jumpType:1,

      // 展示页面
      showPageArray: [
        {label: '我的账户页面', value: 1},
        {label: 'vip服务页面', value: 2},
        {label: 'SVIP服务页面', value: 3},
      ],
      showPage: this.value.vipForm.showPage?this.value.vipForm.showPage:1,

      // UID: this.value.vipForm.showUid,

      newuserShow: this.value.ids > -1? this.value.vipForm.newuserShow: 0,
      vipShow: this.value.ids > -1? this.value.vipForm.vipShow: 0,


      //IOs渠道列表
      channelListIos: [],
      checkAllIos: true,
      checkedIos: [],
      isIndeterminateIos: false,

      //Android渠道列表
      channelListAndroid: [],
      checkAllAndroid: true,
      checkedAndroid: [],
      isIndeterminateAndroid: false,

      //Hm渠道列表
      channelListHm: [],
      checkAllHm: true,
      checkedHm: [],
      isIndeterminateHm: false,

      hmArray:[],
      iosArray:[],
      androidArray: []

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    //hm
    hmHandleCheckAllChange(val) {
      this.checkedHm = val ? this.channelListHm : [];
      this.isIndeterminateHm = false;
      this.hmArray = [];
    },
    hmHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllHm = checkedCount === this.channelListHm.length;
      this.isIndeterminateHm = checkedCount > 0 && checkedCount < this.channelListHm.length;
      this.hmArray = [];
      for(let i=0;i<checkedCount;i++){
        // let hmStr = '4||';
        // hmStr += value[i];
        this.hmArray.push(value[i]);
      }
    },

    //ios
    iosHandleCheckAllChange(val) {
      this.checkedIos = val ? this.channelListIos : [];
      this.isIndeterminateIos = false;
      this.iosArray = [];
    },
    iosHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllIos = checkedCount === this.channelListIos.length;
      this.isIndeterminateIos = checkedCount > 0 && checkedCount < this.channelListIos.length;
      this.iosArray = [];
      for(let i=0;i<checkedCount;i++){
        // let iosStr = '2||';
        // iosStr += value[i];
        // this.iosArray.push(iosStr);
        this.iosArray.push(value[i]);
      }
    },
    //Android
    androidHandleCheckAllChange(val) {
      this.checkedAndroid = val ? this.channelListAndroid : [];
      this.isIndeterminateAndroid = false;
      this.androidArray = [];
    },
    androidHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllAndroid = checkedCount === this.channelListAndroid.length;
      this.isIndeterminateAndroid = checkedCount > 0 && checkedCount < this.channelListAndroid.length;
      this.androidArray = [];
      for(let i=0;i<checkedCount;i++){
        // let androidStr = '1||';
        // androidStr += value[i];
        // this.androidArray.push(androidStr);
        this.androidArray.push(value[i]);
      }
    },

    //获取所有渠道列表
    getChannelListAll() {
      let _this = this;
      getFormData( getAllChannelList ).then((data) => {
        if(data.code == 200){
          for(let item of data.data) {
            if(item.platformType == 4) {
              _this.channelListHm.push(item.channel);
            }
            if(item.platformType == 2) {
              _this.channelListIos.push(item.channel);
            }
            if(item.platformType == 1) {
              _this.channelListAndroid.push(item.channel);
            }
          }
          if(_this.idx > -1) {
            _this.getChannelList();
          }else{
            _this.checkedHm = _this.channelListHm;
            _this.checkedIos = _this.channelListIos;
            _this.checkedAndroid = _this.channelListAndroid;
          }
        }
      })
    },

    //获取banner对应列表
    getChannelList() {
      for(let item of this.vipForm.harmonyShowList) {
        if(item != -1) {
          this.checkedHm.push(item);
          this.hmHandleCheckedChange(this.checkedHm);
        }else if(item == -1){
          this.checkedHm = this.channelListHm;
          this.checkAllHm = true;
        }else if(this.checkedHm.length == 0){
          this.checkAllHm = false;
        }
      }
      if(this.vipForm.harmonyShowList.length == 0) {
        this.checkAllHm = false;
      }
      for(let item of this.vipForm.iosShowList) {
        if(item != -1) {
          this.checkedIos.push(item);
          this.iosHandleCheckedChange(this.checkedIos);
        }else if(item == -1){
          this.checkedIos = this.channelListIos;
          this.checkAllIos = true;
        }else if(this.checkedIos.length == 0){
          this.checkAllIos = false;
        }
      }
      if(this.vipForm.iosShowList.length == 0) {
        this.checkAllIos = false;
      }
      for(let item of this.vipForm.androidShowList) {
        if(item != -1) {
          this.checkedAndroid.push(item);
          this.androidHandleCheckedChange(this.checkedAndroid)
        }else if(item == -1){
          this.checkedAndroid = this.channelListAndroid;
          this.checkAllAndroid = true;
        }else if(this.checkedAndroid.length == 0){
          this.checkAllAndroid = false;
        }
      }
      if(this.vipForm.androidShowList.length == 0) {
        this.checkAllAndroid = false;
      }
    },

    summit() {
      if (this.jumpType != 1 && !this.vipForm.url) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'url不能为空',
          type: 'warning'
        });
        return false
      }
      if (this.jumpType != 1 && !urlReg.test(this.vipForm.url)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'URL地址输入有误',
          type: 'warning'
        });
        return false
      }
      if(!this.vipForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '标题不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.vipForm.showOrder) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.checkedIos.length == 0 && this.checkedAndroid.length == 0 && this.checkedHm.length == 0){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '至少选择一个渠道',
          type: 'warning'
        });
        return;
      }
      this.loading = true
      // let platformChannels = [];
      // if(this.checkedIos.length == this.channelListIos.length && this.checkedAndroid.length == this.channelListAndroid.length) {
      //   platformChannels.push('-1||-1');
      // }else{
      //   if(this.checkedIos.length === this.channelListIos.length) {
      //     platformChannels.push('2||-1');
      //   }else if(this.checkedIos.length > 0){
      //     platformChannels = platformChannels.concat( this.iosArray );
      //   }
      //   if(this.checkedAndroid.length === this.channelListAndroid.length) {
      //     platformChannels.push('1||-1');
      //   }else if(this.checkedAndroid.length > 0){
      //     platformChannels = platformChannels.concat( this.androidArray );
      //   }
      // }

      if(this.vipForm.showUid && this.vipForm.showUid != ''){
        this.vipForm.showUid = this.vipForm.showUid.replace(/\r\n/g,",");
        this.vipForm.showUid = this.vipForm.showUid.replace(/\n/g,",");
        this.vipForm.showUid = this.vipForm.showUid.replace(/，/g,",");
      }

      let param = {};
      if (this.idx > -1) {
        param['id'] = this.vipForm.id
      } else {
        param['id'] = 0
      }
      param['name'] = this.vipForm.name
      param['showOrder'] = this.vipForm.showOrder
      param['showPage'] = this.showPage
      param['jumpType'] = this.jumpType
      param['newuserShow'] = this.newuserShow
      param['vipShow'] = this.vipShow
      param['url'] = this.vipForm.url
      param['showUid'] = this.vipForm.showUid
      // param['showPlatform'] = (this.checkedIos.length > 0 && this.checkedAndroid.length > 0) ? -1 : (this.checkedIos.length > 0 && this.checkedAndroid.length == 0) ? 2 : (this.checkedIos.length == 0 && this.checkedAndroid.length > 0) ? 1 : '';
      // param['platformChannel'] = platformChannels.toString();
      if(this.checkedIos.length == this.channelListIos.length) {
        param['iosChannelArr'] = ['-1']
      }else {
        param['iosChannelArr'] = this.iosArray
      }
      if(this.checkedAndroid.length == this.channelListAndroid.length) {
        param['androidChannelArr'] = ['-1']
      }else {
        param['androidChannelArr'] = this.androidArray
      }
      if(this.checkedHm.length == this.channelListHm.length) {
        param['harmonyChannelArr'] = ['-1']
      }else {
        param['harmonyChannelArr'] = this.hmArray
      }

      postFormData(addOrUpdateVipBanner, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getChannelListAll();
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
  .showBox {
    width: 540px;
    margin-left: 8px;
    border: 1px solid #ededed;
    padding: 24px 0 24px 32px;
  }
</style>
